import { isObject } from '@/util/util'
import { ref } from 'vue'
import IconModule from '@/components/common/icon/iconModule.vue'
import IconPart from '@/components/common/icon/index.vue'
export const useIcon = () => {
  const iconType = ref('')
  const activeCol = ref(0)
  const activeApp = ref(0)
  const iconpart = ref(null)
  const openIcon = (val, i, j, isDefault) => {
    iconType.value = 'apply'
    activeCol.value = i
    activeApp.value = j
    const config = this.isObject(val) ? JSON.parse(JSON.stringify(val)) : undefined
    iconpart.value.open(config, isDefault)
  }
  return { isObject, openIcon, activeCol, activeApp, iconType, IconPart, IconModule }
}